<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <ExpenseActionBar 
          id="office_expenses"
          v-model:search="query.search" 
          v-model:start_date="query.start_date" 
          v-model:end_date="query.end_date"
          v-model:type="query.type" 
          v-model:status="query.status"
          :showOffice="false"
          :showType="false"
        />
      </div>
    </template>

    <template #customLayoutContent>
      <div class=" m-10">
        <Card v-for="type in typeStats" :key="type.type" class="card py-3 px-5">
          <div class="d-flex align-items-center gap-10">
            <h1>{{$t("expenses.types.feesNote")}}</h1>
          </div>
          <div class="flex-lg-row flex-md-row d-flex scroll-x mt-5 py-5">
            <StatCard :title="$t('expenses.total')" :amount="type.amount" :total="type.total" color="secondary" text-color="black" :size-md="4" :size-lg="2"/>
            <StatCard :title="$t('expenses.status.remaining')" :amount="type.remaining_amount" :total="type.remaining_count" :color="type.remaining_color" :size-md="4" :size-lg="2"/>
            <StatCard :title="$t('expenses.status.notValidated')" :amount="type.unvalidated_amount" :total="type.unvalidated_count" :color="type.unvalidated_color" :size-md="4" :size-lg="2"/>
            <StatCard :title="$t('expenses.status.unapproved')" :amount="type.unapproved_amount" :total="type.unapproved_count" :color="type.unapproved_color" :size-md="4" :size-lg="2"/>
            <StatCard :title="$t('expenses.status.rejected')" :amount="type.reject_amount" :total="type.reject_count" :color="type.reject_color" :size-md="4" :size-lg="2"/>
            <StatCard :title="$t('expenses.status.validated')" :amount="type.validated_amount" :total="type.validated_count" :color="type.validated_color" :size-md="4" :size-lg="2"/>
            <StatCard :title="$t('expenses.status.paid')" :amount="type.paid_amount" :total="type.paid_count" :color="type.paid_color" :size-md="4" :size-lg="2"/>
          </div>
        </Card>
        <br>
        <Card class="card py-3 px-5"> 
          <br>
          <UserExpenseList id="user_expense_list" :userExpenses="userExpenses" :loading="isLoading" @reloadData="reloadData" />
          <div :ref="loadMoreTrigger" class="loading" v-if="isFetching">
              Chargement...
          </div>
        </Card>
       
      </div>
    </template>
   

  </SubLayout>
</template>

<script setup> 
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Card from "@/components/Card.vue";
import {onMounted, ref, computed, watch, nextTick} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import ExpenseActionBar from "./components/ExpenseActionBar.vue";
import StatCard from "../../components/StatCard.vue";
import { useInfiniteScroll } from "@/composables/infiniteScroll";
import OfficeExpenseList from "./components/OfficeExpenseList.vue";
import UserExpenseList from "./components/UserExpenseList.vue";

const route = useRoute()
const store = useStore()

const office = route.params.office
const company = route.params.company

const title = ref("breadcrumbs.expenses.title")

const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expenses.userExpense',
    path: ''
  }
])
const isLoading = ref(false)


const query = ref({
  start_date: '',
  end_date: '',
  search: "",
  office: office,
  user_id: route.params.id,
  status: '',
  type: ""
})

const typeStats = ref([])

const userExpenses = ref([])
const currentPage = ref(1);
const lastPage = ref(null);

watch(() => query.value, (value) => {
  currentPage.value = 1
  lastPage.value = null

  if (!isLoading.value) {
    loadUserExpenseStats()
    loadUserExpenseList(true)
  }
}, {deep: true})

function loadUserExpenseStats () {
  if(query.value.end_date && query.value.start_date){
    try {
      isLoading.value = true
      store.dispatch('expenses/loadUserExpenseStats', query.value).then(resp => {
        typeStats.value = resp.data.types
      })
    }catch (e) {

    }finally {
    
      isLoading.value = false
    }
  }

}

const canLoadMore = () => lastPage.value === null || currentPage.value <= lastPage.value;

function loadUserExpenseList (clearOldData = false) {
  if(query.value.end_date && query.value.start_date){
    if (lastPage.value !== null && currentPage.value > lastPage.value) return;

    isLoading.value = true
    store.dispatch('expenses/loadUserExpenseList', {...query.value, page: currentPage.value})
        .then(resp => {
          currentPage.value = resp.data.expenses.current_page + 1
          lastPage.value = resp.data.expenses.last_page
          if(clearOldData) {
            userExpenses.value = [...resp.data.expenses.data]
          } else {
            userExpenses.value = [...userExpenses.value,...resp.data.expenses.data]
          }

        }).finally(() => isLoading.value = false)
  }
}

const { loadMoreTrigger, isFetching } = useInfiniteScroll(loadUserExpenseList, canLoadMore)

function reloadData() {
  loadUserExpenseStats()
  loadUserExpenseList(true)
}

onMounted(() => {
  loadUserExpenseStats()
  loadUserExpenseList()
})

</script>
